import React from 'react';
import { useLocation } from 'react-router-dom';
import * as queryString from 'query-string';

import { useAuth } from '../auth/AuthContext';
import { getMergedDocumentsFile } from '../api';

function DocApiDownload(props: any) {
  const { accessToken } = useAuth();
  const location = useLocation();

  if (!accessToken) {
    console.error('Unauthenticated request');
    return null;
  }

  const query = queryString.parse(location.search);
  getMergedDocumentsFile(query.forms as string, accessToken);

  return (
    <section className="main">
      <div className="doc-header">
        <h1>The download will begin soon...</h1>
      </div>
    </section>
  );
}

export default DocApiDownload;
